import { render, staticRenderFns } from "./SpTradesTab.vue?vue&type=template&id=12be9ff4&"
import script from "./SpTradesTab.vue?vue&type=script&lang=js&"
export * from "./SpTradesTab.vue?vue&type=script&lang=js&"
import style0 from "./SpTradesTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/geras/Documents/electros/magic-electros-crm/vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12be9ff4')) {
      api.createRecord('12be9ff4', component.options)
    } else {
      api.reload('12be9ff4', component.options)
    }
    module.hot.accept("./SpTradesTab.vue?vue&type=template&id=12be9ff4&", function () {
      api.rerender('12be9ff4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/vue/pages/LeadView/tabs/SpTradesTab.vue"
export default component.exports